import { Checkbox, FormControlLabel, FormControlLabelProps } from "@mui/material";
const CheckBoxUnControlled = (props: Omit<FormControlLabelProps, "control">) => {
    return <FormControlLabel {...props} control={<Checkbox defaultChecked={props.defaultChecked} />} />;
};

export default CheckBoxUnControlled;
